import { render, staticRenderFns } from "./CreateCubicRuleContent.vue?vue&type=template&id=6061449b&scoped=true&"
import script from "./CreateCubicRuleContent.vue?vue&type=script&lang=js&"
export * from "./CreateCubicRuleContent.vue?vue&type=script&lang=js&"
import style0 from "./CreateCubicRuleContent.vue?vue&type=style&index=0&id=6061449b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6061449b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6061449b')) {
      api.createRecord('6061449b', component.options)
    } else {
      api.reload('6061449b', component.options)
    }
    module.hot.accept("./CreateCubicRuleContent.vue?vue&type=template&id=6061449b&scoped=true&", function () {
      api.rerender('6061449b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Rates/ModalComponents/CreateCubicRuleContent.vue"
export default component.exports